import { render, staticRenderFns } from "./StoryView.vue?vue&type=template&id=97994132&scoped=true&"
import script from "./StoryView.vue?vue&type=script&lang=js&"
export * from "./StoryView.vue?vue&type=script&lang=js&"
import style0 from "./StoryView.vue?vue&type=style&index=0&id=97994132&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97994132",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Touch from 'vuetify/lib/directives/touch'
installDirectives(component, {Touch})
